import { getPreviewImageUrl } from "@/utils/chat/index";
import { message as toast } from "antd";
import React, { useCallback, useEffect, useMemo, useState, useRef, useContext } from "react";
import styles from "./imagecard.module.less";
import IconFont from "@/components/icon";
import { ChatMessage } from "@/types/chat";
import { connect } from "dvajs";
import { createUploadTask } from "@/server/FileService";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { nanoid } from "nanoid";
import { TaskState } from "@jd/jdee-fs-desktop";
import { getPreviewImageModal } from "@/components/chat/utils/commonMessageModal";
import { isArray } from "lodash";
import lodashGet from "lodash/get";

interface IAIImageCardProps {
  readonly?: boolean;
  [keys: string]: any;
}
function AIImageCard(props: IAIImageCardProps) {
  const { file, updateLLMInfo, message, fileList = [], readonly = false } = props;
  console.log("tj:>>[AIImageCard]>>>", message);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);
  const {
    fileService: { imAppKey }
  } = appRuntimeEnv;

  const [loadingStatus, setLoadingStatus] = useState<string>("loading");

  const files = useMemo(() => {
    if (fileList?.length) {
      return fileList;
    }
    let files = lodashGet(message, "data.0.files", []);
    files = isArray(files) ? files : [];
    console.log("tj:>>[ImagesCard]>>>dataInfo>>>", files);
    return files;
  }, [message, fileList]);

  // 图片预览列表
  const imageFiles = useMemo(() => {
    return (files || [])?.map((f: any) => {
      return {
        muuid: f?.fileId || f?.fileKey,
        url: f?.fileUrl,
        fileName: f?.filename,
        kind: "image"
      };
    });
  }, [files]);

  // 点击预览
  const handleClick = useCallback(() => {
    const img = {
      muuid: file.fileId || file.fileKey,
      url: file.fileUrl || file.url,
      fileName: file.name,
      size: file.size,
      kind: "image"
    };
    console.log("tj:>>>[AIImageCard]>>>handleClick>", file, img);
    getPreviewImageModal({
      message: img,
      isMergeForward: true,
      modalMessages: imageFiles?.length ? imageFiles : [img]
    });
  }, [file, imageFiles]);

  const handleDelete = useCallback(
    (e, id) => {
      e?.stopPropagation();
      const newFiles = files?.filter((file: any) => {
        return file.fileId !== id;
      });
      updateLLMInfo({
        images: newFiles
      });
    },
    [updateLLMInfo, files]
  );

  const handleUpdateFileInfo = useCallback(
    (fileInfo: any) => {
      const idx = (files || []).findIndex((f: any) => f.fileId === fileInfo.fileId);
      if (idx > -1) {
        files[idx] = {
          ...files[idx],
          ...fileInfo
        };
      }
      updateLLMInfo({
        images: files
      });
    },
    [files, updateLLMInfo]
  );

  const doUploadFile = useCallback(
    (file: any) => {
      if (readonly) {
        return;
      }
      const { fileName, pageType, type } = file;
      if (!file.fileId) {
        file.fileId = nanoid(10);
      }
      if (file.isUpload && !file.task) {
        const task = createUploadTask(file.fileId, file.file, { appKey: imAppKey });
        file.task = task;
        task?.on("state", (state: any) => {
          if (state.state === TaskState.UPLOADING) {
            file.state = state.state;
            // update file
            handleUpdateFileInfo(file);
          }
          if (state.state === TaskState.COMPLETED) {
            file.state = state.state;
            file.url = state.downloadUrl;
            // update file
            handleUpdateFileInfo(file);
          }
          if (state.state === TaskState.FAILED) {
            file.state = state.state;
            // update file
            handleUpdateFileInfo(file);
            toast.warning("上传失败，请重新上传");
            // 处理上传失败状态变化
          }
        });
        task?.start();
      }
    },
    [handleUpdateFileInfo, imAppKey, readonly]
  );

  const loadingComp = useMemo(() => {
    return loadingStatus ? (
      <div className={styles["loading-container"]}>
        <div className={styles["loading-spinner"]} />
      </div>
    ) : null;
  }, [loadingStatus]);

  useEffect(() => {
    doUploadFile(file);
  }, [file, doUploadFile]);
  return (
    <div
      key={`file_${file.fileId || file.fileKey}`}
      className={`${styles["image-item-wrap"]} ${styles[loadingStatus]}`}
      onClick={handleClick}
    >
      {loadingComp}
      <img
        src={getPreviewImageUrl(file.fileUrl || file.url)}
        onLoad={() => setLoadingStatus("")}
        onError={() => setLoadingStatus("error")}
      />
      {!readonly ? (
        <div className={styles["item-icon"]}>
          <IconFont
            type="iconjs_ic_error"
            onClick={(e) => handleDelete(e, file.fileId || file?.fileKey)}
          />
        </div>
      ) : null}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee,
    files: chat.llmInfo?.images,
    llmInfoReady: chat.llmInfo?.isReady
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    updateLLMInfo(data: any) {
      dispatch({ type: "chat/updateLLMInfo", payload: data });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AIImageCard);
